import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FiPlus, FiSearch, FiEye } from 'react-icons/fi';
import Card from '../Components/Card';
import DataTable from '../Components/DataTable';
import { useCheckinList } from '../hooks/useCheckins';
import { formatDate } from '../utils/format';

const columns = [
  { key: 'retailerName', header: 'Retailer' },
  { key: 'punchDate', header: 'Date', width: 120, render: (r) => formatDate(r.punchDate) },
  { key: 'visitOutcome', header: 'Outcome', render: (r) => r.visitOutcome || <span className="hrms-muted">—</span> },
  {
    key: 'geo', header: 'Geo', width: 240,
    render: (r) => {
      const coords = (r.latitude && r.longitude) ? `${r.latitude}, ${r.longitude}` : null;
      if (!r.address && !coords) return <span className="hrms-muted">—</span>;
      return (
        <div>
          {r.address && <div>{r.address}</div>}
          {coords && <div className="hrms-muted" style={{ fontSize: '0.78rem' }}>{coords}</div>}
        </div>
      );
    },
  },
];

export default function CheckInsListPage() {
  const navigate = useNavigate();
  const [term, setTerm] = useState('');
  const [search, setSearch] = useState('');
  const { data: rows, isLoading, isError, error } = useCheckinList(search || undefined);

  const submitSearch = (e) => { e.preventDefault(); setSearch(term.trim()); };

  return (
    <div className="hrms-page">
      <div className="hrms-toolbar">
        <h1 className="hrms-page-title">Check-ins</h1>
        <div className="d-flex gap-2">
          <Button variant="light" onClick={() => navigate('/checkins/drafts')}>Drafts</Button>
          {/* "New" picks a retailer first (check-in is recorded from a retailer). */}
          <Button className="hrms-btn-primary" onClick={() => navigate('/retailers')}>
            <FiPlus className="me-1" /> New check-in
          </Button>
        </div>
      </div>

      <Card>
        <Form onSubmit={submitSearch} className="mb-3" style={{ maxWidth: 360 }}>
          <InputGroup>
            <Form.Control placeholder="Search by retailer…" value={term} onChange={(e) => setTerm(e.target.value)} />
            <Button variant="light" type="submit"><FiSearch /></Button>
          </InputGroup>
        </Form>

        {isError ? (
          <div className="hrms-field-error">{error?.friendlyMessage || 'Failed to load check-ins.'}</div>
        ) : (
          <DataTable
            columns={columns}
            rows={rows}
            loading={isLoading}
            rowKey="punchInGuid"
            emptyMessage="No check-ins for your stations yet."
            massActions={[{ label: 'Export (coming soon)', onClick: () => {} }]}
            rowActions={(row) => (
              <Button size="sm" variant="light" title="Open retailer" onClick={() => navigate(`/retailers/${row.retailerCmGuid}`)}><FiEye /></Button>
            )}
          />
        )}
      </Card>
    </div>
  );
}
